import React from "react";
import Page from "../../components/Page";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Slogan from "../../components/Slogan";
import About from "../../components/About";
import CTA from "../../components/CTA";
import { apiEndpoint } from "../../prismic-configuration";
import ContentBox from "../../components/ContentBox";
import CarouselDynamic from "../../components/CarouselDynamic";
import ContentBoxDynamic from "../../components/ContentBoxDynamic";
import Prismic from "@prismicio/client";
import CatalogDynamic from "../../components/CatalogDynamic";

const Promotiekleding = ({ doc, brands, pageContent, lang }) => {
  const createMarkup = (content) => {
    return { __html: content };
  };

  const { data } = doc;

  return (
    <Page
      title="MERLET | Promotiekleding"
      description="Breed assortiment aan promotiekleding om uw firma extra in de kijker te zetten."
    >
      <Header />

      {data.body.map((body, i) => {
        switch (body.slice_type) {
          case "slogan":
            return (
              <Slogan
                sx={{
                  pt: "200px",
                }}
                data={body}
                key={`slice-${i}`}
              />
            );
          case "title_with_text":
            return <About data={body} column={2} key={`slice-${i}`} />;
          case "content_box":
            return <ContentBoxDynamic data={body} key={`slice-${i}`} />;
          case "carousel":
            return (
              <ContentBox>
                <CarouselDynamic
                  itemsPerPage={1}
                  width="90%"
                  maxWidth="996px"
                  mx="auto"
                  pb={5}
                  data={body}
                  key={`slice-${i}`}
                />
              </ContentBox>
            );
          case "brand_catalogus_list":
            return <CatalogDynamic merken={brands} />;
          case "cta":
            return <CTA data={body} key={`slice-${i}`} />;
          default:
            return null;
        }
      })}
      <Footer />
    </Page>
  );
};

Promotiekleding.getInitialProps = async (context) => {
  const clothes = await Prismic.client(apiEndpoint).getByUID(
    "products",
    "promotiekleding",
    {}
  );

  const brands = await Prismic.client(apiEndpoint).query([
    Prismic.Predicates.at("document.type", "brand"),
    Prismic.Predicates.at("my.brand.categories.category", clothes.id),
  ]);

  return { doc: clothes, brands: brands.results };
};

export default Promotiekleding;
